var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconKey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7,13.7a1.7,1.7,0,0,1-1.2-2.9,1.69,1.69,0,0,1,2.4,0A1.7,1.7,0,0,1,7,13.7ZM7,18a5.77,5.77,0,0,1-4.25-1.75A5.77,5.77,0,0,1,1,12,5.77,5.77,0,0,1,2.75,7.75,5.77,5.77,0,0,1,7,6a5.76,5.76,0,0,1,3.15.85,5.72,5.72,0,0,1,2.13,2.57h8.89L24,12.25l-4.17,3.83-2.2-1.6-2.2,1.6-1.88-1.51H12.28a5.73,5.73,0,0,1-2,2.47A5.52,5.52,0,0,1,7,18Zm0-1.5a4.21,4.21,0,0,0,2.67-1,4.28,4.28,0,0,0,1.58-2.47H14.1l1.35,1.13,2.2-1.58,2.05,1.56,2.13-2-1.28-1.28h-9.3a4.3,4.3,0,0,0-1.5-2.41A4.17,4.17,0,0,0,7,7.5,4.47,4.47,0,0,0,2.5,12,4.47,4.47,0,0,0,7,16.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconKey);
export default __webpack_public_path__ + "static/media/icon-key.ed125a95d6f22e39eca59e2fbcc00622.svg";
export { ForwardRef as ReactComponent };